















import { Vue, Component, Emit } from "vue-property-decorator";
import SearchTextField from "@/components/SearchTextField.vue";

@Component({
  components: {
    SearchTextField
  }
})
export default class RequestSearch extends Vue {
  searchText = "";

  @Emit("search")
  emitSearch() {
    return this.searchText;
  }
}
